import { FC, useCallback, useRef, useState } from 'react'
import { SendIcon } from '../../icons/SendIcon'
//components
import { useSendMessage } from '../../../hooks/useSendMessage'
import { filesState } from '../../../states/messageState'
import { useSetRecoilState } from 'recoil'
import { FooterContent } from '../FooterContent'
import { Button } from '../../Button'
import { useSubmitInquiry } from '../../../hooks/useSubmitInquiry'
import styled, { css } from 'styled-components'

export const MAX_UPLOAD_IMAGE_BYTE_SIZE = 15000000

export const UploadImage: FC = () => {
  const { handleAddSenderParent, handleAddMessage } = useSendMessage()
  const { handleSubmitInquiry } = useSubmitInquiry()

  const [fileResults, setFileResults] = useState<string[]>([])

  const setFiles = useSetRecoilState(filesState)

  const inputRef = useRef<HTMLInputElement>(null)

  const clearImages = () => {
    setFileResults([])
    setFiles([])
  }

  const isMaxImageCount = (length: number) => length > 3

  const handleFileChange = useCallback((files: FileList | null) => {
    if (!files) return

    const arrayFiles = Array.from(files)
    if (isMaxImageCount(files.length)) {
      alert('添付できる画像は3枚までです')
      return
    }
    const isOverMaxByteSize = arrayFiles.some((file) => file.size > MAX_UPLOAD_IMAGE_BYTE_SIZE)
    if (isOverMaxByteSize) {
      alert('1ファイルの上限サイズ15MBを超えています')
      return
    }
    setFiles((prev) => [...prev, ...arrayFiles])
    arrayFiles.forEach((file) => {
      const reader = new FileReader()
      reader.addEventListener('load', () => {
        if (reader.result) {
          const result = reader.result.toString()
          setFileResults((prev) => [...prev, result])
        }
      })
      reader.readAsDataURL(file)
    })
  }, [])

  const handleSubmit = async () => {
    if (!fileResults.length) return
    if (isMaxImageCount(fileResults.length)) {
      alert('添付できる画像は3枚までです')
      clearImages()
      return
    }
    fileResults.forEach(async (file, index) => {
      const addMessage = index === 0 ? handleAddSenderParent : handleAddMessage
      await addMessage('user', `file:${file}`)
    })
    handleSubmitInquiry()
  }

  return (
    <FooterContent isWide>
      <StyledImageWrap>
        <input
          ref={inputRef}
          type="file"
          multiple
          max={3}
          accept=".png, .jpg, .jpeg"
          onChange={({ target }) => handleFileChange(target.files)}
          hidden
        />
        <div>
          <Button buttonType="contained" onClick={() => inputRef.current?.click()}>
            ファイルを選択
          </Button>
          <span
            css={css`
              padding-left: 8px;
            `}
          >
            {fileResults.length ? `${fileResults.length}ファイル` : '選択されていません'}
          </span>
        </div>

        <Button buttonType="icon" onClick={handleSubmit} disabled={!fileResults.length}>
          <SendIcon disabled={!fileResults.length} />
        </Button>
      </StyledImageWrap>
    </FooterContent>
  )
}

const StyledImageWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
